import { render, staticRenderFns } from "./ReporteStockCreate.vue?vue&type=template&id=66bae981&scoped=true"
import script from "./ReporteStockCreate.vue?vue&type=script&lang=js"
export * from "./ReporteStockCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bae981",
  null
  
)

export default component.exports